import { TaskType } from '@stuut/api/models';

export const TaskTypeMap = {
  [TaskType.DisputeActivate]: {
    actionBtn: 'Activate Dispute',
    cancelBtn: 'Reject',
    cancelIcon: 'fa-ban',
    subtitle: 'Dispute details',
    title: 'Activate draft dispute',
    toastMsg: 'Dispute activated!',
  },
  [TaskType.DisputeCreate]: {
    actionBtn: 'Create Dispute',
    cancelBtn: 'Dismiss',
    subtitle: 'Dispute details',
    title: 'Create Dispute Case',
    toastMsg: 'Dispute created!',
  },
  [TaskType.DisputeResolution]: {
    actionBtn: 'Mark Resolved',
    cancelBtn: 'Dismiss',
    cancelIcon: 'fa-ban',
    title: 'Review and mark resolved',
    toastMsg: 'Dispute resolved!',
  },
  [TaskType.DisputeUpdate]: {
    actionBtn: 'Update Dispute',
    cancelBtn: 'Dismiss',
    cancelIcon: 'fa-ban',
    subtitle: 'Update dispute:',
    title: 'Update dispute case details',
    toastMsg: 'Dispute updated!',
  },
};
